var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"dal-slider-item"},[(_vm.src)?_c('figure',{staticClass:"figure"},[_c('img',{staticClass:"image",attrs:{"src":_vm.src,"draggable":"false","alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('p',[_vm._t("default")],2),_vm._v(" "),_c('DalSliderAudio',{attrs:{"src":_vm.audioSrc,"trackTitle":_vm.trackTitle}})],1),_vm._v(" "),_c('div',{staticClass:"background",style:({
      'background-image': ("url(" + _vm.background + ")")
    })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b59182","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dal/DalSliderItem.vue
// module id = null
// module chunks = 